/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEvent } from '../../models/calendar-event';

export interface ApiV0CalendareventGetAllCalendarEventsGet$Plain$Params {
  companyId?: string;
}

export function apiV0CalendareventGetAllCalendarEventsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0CalendareventGetAllCalendarEventsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalendarEvent>>> {
  const rb = new RequestBuilder(rootUrl, apiV0CalendareventGetAllCalendarEventsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CalendarEvent>>;
    })
  );
}

apiV0CalendareventGetAllCalendarEventsGet$Plain.PATH = '/api/v0/calendarevent/getAllCalendarEvents';
